<template>
    <h2 class="title" :id="props.id" :class="{ right: props.position === 1, center: props.position === 2 }">
        {{ props.title }}
    </h2>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    id: String,
    title: String,
    position: Number
});

</script>

<style lang="scss" scoped>
@import '@/styles/theTitle';
</style>